import type { DummyFoods } from './dummyFoods'

export const groundMeat: DummyFoods = {
  'Ground meat': {
    Beef: {
      '70/30': {
        Cooked: ['Ground beef (70/30) (cooked)'],
        Raw: ['Ground beef (70/30) (raw)'],
      },
      '80/20': {
        Cooked: ['Ground beef (80/20) (cooked)'],
        Raw: ['Ground beef (80/20) (raw)'],
      },
      '90/10': {
        Cooked: ['Ground beef (90/10) (cooked)'],
        Raw: ['Ground beef (90/10) (raw)'],
      },
    },
    Lamb: {
      Cooked: ['Ground lamb (cooked)'],
      Raw: ['Ground lamb (raw)'],
    },
    Pork: {
      '84/16': {
        Cooked: ['Ground pork (84/16) (cooked)'],
        Raw: ['Ground pork (84/16) (raw)'],
      },
      '96/4': {
        Cooked: ['Ground pork (96/4) (cooked)'],
        Raw: ['Ground pork (96/4) (raw)'],
      },
    },
    Turkey: {
      '85/15': {
        Cooked: ['Ground turkey (85/15) (cooked)'],
        Raw: ['Ground turkey (85/15) (raw)'],
      },
      '93/7': {
        Cooked: ['Ground turkey (93/7) (cooked)'],
        Raw: ['Ground turkey (93/7) (raw)'],
      },
    },
  },
}
